<template>
  <div
    ref="navbar"
    class="app-navbar"
  >
    <nav>
      <PrmButton
        size="small"
        text
        severity="primary"
        type="button"
        icon="pi pi-arrow-left"
        :disabled="disabled"
        data-qa="app-navbar__back"
        @click="historyBack"
      />
      <SeparatorAppNavbar />
      <slot />
    </nav>
  </div>
</template>

<script lang="ts" setup>
import PrmButton from '@NitrexGroup/primevue/button';
import {
  onBeforeUnmount,
  onMounted,
  useTemplateRef,
} from 'vue';

import {
  rafCallback,
} from '../../utils/raf';

import SeparatorAppNavbar from './separator-app-navbar.vue';

defineProps<{
  disabled?: boolean,
}>();

const navbar = useTemplateRef<HTMLElement>('navbar');

function historyBack() {
  window.history.back();
}

const onResize = rafCallback(() => {
  if (!navbar.value) {
    return;
  }
  document.documentElement.style.setProperty('--navbar-sidebar-width', `${navbar.value!.offsetWidth}px`);
});
onMounted(() => {
  onResize();
  window.addEventListener('resize', onResize);
  navbar.value!.addEventListener('resize', onResize);
});
onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize);
  navbar.value!.removeEventListener('resize', onResize);
});
</script>

<style scoped lang="scss">
.app-navbar {
  @media print {
    width: 0;
    overflow: none;
  }

  nav {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: .5rem;
    align-items: stretch;
    padding: .5rem;
    border-right: 1px solid var(--color-103);
    overflow-y: auto;
  }
}
</style>
